export default __webpack_public_path__ + "static/media/homePin.a5737f21.svg";